import script from "./ElementLabelFloating.vue?vue&type=script&lang=js"
export * from "./ElementLabelFloating.vue?vue&type=script&lang=js"

import "./ElementLabelFloating.vue?vue&type=style&index=0&id=c2189514&lang=scss"

const __exports__ = script;

export default __exports__